import { render, staticRenderFns } from "./EditPolicy.vue?vue&type=template&id=0c9b9a68&"
import script from "./EditPolicy.vue?vue&type=script&lang=js&"
export * from "./EditPolicy.vue?vue&type=script&lang=js&"
import style0 from "./EditPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports